import React, { useEffect, useState } from "react";
import { Table, Input, Button } from "antd";

export const AIOpsVariablesEditableTable = (props) => {
  const { onChange, value: variablesValue = [], initData } = props;
  const [dataSource, setDataSource] = useState([]);

  let initialData = null;

  if(initData) {
    initialData = initData;
  } else 
  // if (variablesValue == undefined) return <></>;
    initialData = [
    {
      key: "1",
      name: "ODA_SPARK_CORES_MAX",
      defaultValue: "",
      overrideValue: "",
    },
    {
      key: "2",
      name: "ODA_SPARK_EXECUTOR_INSTANCES",
      defaultValue: "",
      overrideValue: "",
    },
    {
      key: "3",
      name: "ODA_SPARK_EXECUTOR_CORES",
      defaultValue: "",
      overrideValue: "",
    },
    {
      key: "4",
      name: "ODA_EXECUTOR_MEMORY",
      defaultValue: "4g",
      overrideValue: "",
    },
    {
      key: "5",
      name: "ODA_DRIVER_MEMORY",
      defaultValue: "4g",
      overrideValue: "",
    },
    {
      key: "6",
      name: "ODA_SQL_SHUFFLE_PARTITIONS",
      defaultValue: "4",
      overrideValue: "",
    },
    {
      key: "7",
      name: "ODA_THRIFT_PORT",
      defaultValue: "7000",
      overrideValue: "",
    },
  ];

  const updatedData = () =>
    variablesValue.reduce(
      (accumulated, current) => {
        const existingItem = accumulated.find(
          (item) => item.name === current.name,
        );
        if (existingItem) {
          // if (current.value !== existingItem.defaultValue) {
          existingItem.overrideValue = current.value;
          // }
        } else {
          const newKey = (accumulated.length + 1).toString();
          accumulated.push({
            key: newKey,
            name: current.name,
            defaultValue: "",
            overrideValue: current.value,
          });
        }

        return accumulated;
      },
      [...initialData],
    );

  useEffect(() => {
    const ds = updatedData();
    setDataSource(ds);
  }, [JSON.stringify(variablesValue)]);

  const nonEditableNames = initialData.map((item) => item.name);

  const handleDelete = (record) => {
    if (!nonEditableNames.includes(record.name)) {
      const newData = dataSource.filter((item) => item.key !== record.key);
      setDataSource(newData);
      onChange(newData);
    }
  };

  const handleAdd = () => {
    const newEntry = {
      key: `${dataSource.length + 1}`,
      name: `New_Entry_${dataSource.length + 1}`,
      defaultValue: "",
      overrideValue: "",
    };
    setDataSource([...dataSource, newEntry]);
    onChange([...dataSource, newEntry]);
  };

  const handleOverrideChange = (key, value) => {
    const newData = dataSource.map((item) => {
      if (item.key === key) {
        return { ...item, overrideValue: value };
      }
      return item;
    });
    setDataSource(newData);
    onChange(newData);
  };

  const handleNameChange = (key, value) => {
    if (!nonEditableNames.includes(value)) {
      const newData = dataSource.map((item) => {
        if (item.key === key) {
          return { ...item, name: value };
        }
        return item;
      });
      setDataSource(newData);
      onChange(newData);
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) =>
        nonEditableNames.includes(text) ? (
          <> {text} </>
        ) : (
          <Input
            value={text}
            onChange={(e) => handleNameChange(record.key, e.target.value)}
            // disabled={nonEditableNames.includes(text)}
          />
        ),
    },
    {
      title: "Default Value",
      dataIndex: "defaultValue",
      key: "defaultValue",
    },
    {
      title: "Override Value",
      dataIndex: "overrideValue",
      key: "overrideValue",
      render: (text, record) => (
        <Input
          value={text}
          onChange={(e) => handleOverrideChange(record.key, e.target.value)}
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) =>
        nonEditableNames.includes(record.name) ? (
          <span></span>
        ) : (
          <Button type="link" onClick={() => handleDelete(record)}>
            Delete
          </Button>
        ),
      width: "106px",
    },
  ];

  return (
    <>
      <Button type="primary" onClick={handleAdd} style={{ marginBottom: 16 }}>
        Add Variables
      </Button>
      <Table dataSource={dataSource} columns={columns} pagination={false} />
    </>
  );
};
